import { useState, useEffect, useRef, useContext } from 'react';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import PageContext from '../sub-components/PageContext';
import ViewCompaniesModal from '../sub-components/ViewCompaniesModal';
import standardSearch from '../functions/standardSearch';
import applyFilters from '../functions/applyFilters';
import { HttpContext } from '../../api-services/HttpService';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import PageInputRedux from '../sub-components/PageInputReduxTooltopCopy.jsx';
import ConsortiumSearchRow from '../sub-components/ConsortiumSearchRow'; 
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import ButtonComponent from '../sub-components/ButtonComponent.jsx';

const ConsortiumSearchPage = () => {
    // initialize http context 
    const {
        GET, 
    } = useContext(HttpContext);
    // initialize redux persisent state for search 
    const consortiumSearch = useSelector((state) => state.consortiumSearch);
    const dispatch = useDispatch();
    const { 
        setConsortiumSearch, 
    } = bindActionCreators(actionCreators, dispatch);
    // initialize state for table
    const [showDataList, setShowDataList] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [tableHeader, setTableHeader] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize state for company numbers modal 
    const [viewModal, setViewModal] = useState(false);
    const [viewCompany, setViewCompany] = useState({});
    const [enableReset, setEnableReset] = useState(false);
    // initailize ref to determine initial render
    const initialRender = useRef(true);

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader,stickyEnabled,rowIndex,selectableRows) =>{
        return(
            <>
                <ConsortiumSearchRow row={row} count={count} tableHeader={tableHeader} selectableRows={selectableRows}/>
            </>
        ); 
    }  

    // make get request to get consortium data
    const getConsortiumData = () => {
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise ((resolve, reject) => {
            GET('/consortium/consortiumSearchPage', {}).then(res => {
                // set state
                setDataList(dataList => dataList = res['data']['ConsortiumSearchData']); 
                setShowDataList(showDataList => showDataList = res['data']['ConsortiumSearchData']); 
                setTableHeader(tableHeader => tableHeader = res['data']['ConsortiumSearchCols']); 
                // stop showing spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // resolve response
                resolve(res);
            }).catch(err => {
                setShowSpinner(showSpinner => showSpinner = false);
                // reject on error
                reject(err); 
            }); 
        }); 
    }

    // useEffect to run on initial render
    useEffect(() => {
        getConsortiumData().then(res => {
            console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
    }, []); 

    // useEffect to run list of search/filter functions on table data
    useEffect(() => { 
        // do not run on initial render
        if (!initialRender.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardSearch, value: consortiumSearch, flag: 0, cols: ['consortiumid', 'mastercompanyname', 'mastercompanyid', 'primaryccrm']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(dataList, functionList);
            // update showDataList
            setShowDataList(showDataList => showDataList = filteredList);
        }
        else{
            initialRender.current = false;
        }
        
    }, [dataList, consortiumSearch]);

    // object to pass variables to context 
    const settings = {
        viewModal, 
        setViewModal, 
        viewCompany, 
        setViewCompany, 
    };

    //reset functionality 
    const resetToDefault = () => {
        setConsortiumSearch('');
    }

    const enableResetAll = () => {
        if(consortiumSearch !== ''
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [consortiumSearch])

    return (
        <div class='summary-page'>
            {/* wrap children so they can access variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* modal for viewing sub companies. Default is hidden state */}
                <ViewCompaniesModal flag={1} headerKey='consortiumid' />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* label for search column dropdown and search bar */}
                        <div className="mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap p-3'>
                                <div className='d-flex'>
                                    <div className='align-self-center'>Search By</div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/CompanyProfilePage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={process.env.REACT_APP_MASTER_COMPANY_ID_TAG}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/CompanyProfilePage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/CompanyProfilePage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/SubCompanySearchPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Company"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/SubCompanySearchPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/SubCompanySearchPage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/ConsortiumSearchPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Consortium"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/ConsortiumSearchPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/ConsortiumSearchPage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <hr style={{ margin: 0 }}/>
                            <div className='d-flex p-3'>
                                <div className='pe-2 align-self-center'>
                                    Search Company by
                                </div>
                                <div className= "pe-3">
                                    <PageInputRedux tag='' value={consortiumSearch} setValue={setConsortiumSearch} />
                                </div>
                                <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                </div>
                            </div>

                        </div>
                        {/* table to display company data with links for drilldown */}
                        <div className="flex-grow-1" style={{ borderRadius: '12px', background: '#fff' }}>
                            <OrderedDataTable RowComponent={RowComponent} tableHeader={tableHeader} dataList={showDataList} showSpinner={showSpinner} numToPage={50} skeletonHeight='28vh'
                                sortingEnabled={true} stickyFirstColumnEnabled={false} selectableRows/>
                        </div>
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    ); 
}

export default ConsortiumSearchPage; 